import type { FC, PropsWithChildren } from 'react';

import { makeClassesByStyles } from '@dcentralexpedientedigital/fe-ui/utils/classes';

export interface IFooterProps {
    className?: string;
}
const cx = makeClassesByStyles();

export const Footer: FC<PropsWithChildren<IFooterProps>> = ({ className, children }) => {
    return <div className={cx(className, 'bg-footer-bg pt-7 pb-16 px-3 lg:pb-7')}>{children}</div>;
};
